export default "__VITE_ASSET__DnW8au$V__"